<template>
    <span v-if="mostrarBtnFaturarPagamento">
        <b-button variant="success" @click.stop="abrirModalFaturar()">
            <i class="fa fa-file-text-o"></i> Faturar Pagamento
        </b-button>
        <b-modal
            id="modalFaturarPagamento"
            v-model="mostrarModalFaturarPagamento"
            centered
            hide-header
            body-class="text-center px-4 pt-4"
            footer-class="justify-content-center border-0 pb-4"
        >
            <div class="text-warning mb-3">
                <i class="fa fa-exclamation-triangle fa-3x"></i>
            </div>
            <h4 class="mb-3">Faturar Pagamento</h4>
            <div class="text-left mb-3">
                <p class="mb-1"><strong>Pagamento:</strong> {{ pagamento.protocolo }}</p>
                <p class="mb-1">
                    <strong>Quantidade de serviços:</strong>
                    {{ (pagamento.comprometimentos || []).length }}
                </p>
                <p class="mb-0">
                    <strong>Valor total:</strong>
                    {{ pagamento.valorTotal | toCurrency }}
                </p>
            </div>
            <b-form-group class="text-left">
                <label for="tipoMovimento">Tipo de Movimento</label>
                <b-form-select
                    id="tipoMovimento"
                    v-model="tipoMovimento"
                    :options="tiposMovimentosOptions"
                    @input="$v.tipoMovimento.$touch()"
                    :state="$v.tipoMovimento.$error ? false : null"
                ></b-form-select>
                <b-form-invalid-feedback>
                    Selecione um tipo de movimento
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group class="text-left mb-0">
                <label for="dataVencimentoFaturamentoRM"
                    >Data de Vencimento</label
                >
                <date-picker
                    id="dataVencimentoFaturamentoRM"
                    v-model="dataVencimentoFaturamentoRM"
                    :config="$datePickerOptions2"
                    @input="$v.dataVencimentoFaturamentoRM.$touch()"
                >
                </date-picker>
                <b-form-invalid-feedback
                    :state="
                        $v.dataVencimentoFaturamentoRM.$error ? false : null
                    "
                >
                    A data de vencimento é obrigatória
                </b-form-invalid-feedback>
            </b-form-group>
            <div slot="modal-footer">
                <b-button
                    variant="danger"
                    @click.stop="fecharModalFaturar()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="success"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarFaturarPagamento()"
                    class="ml-2"
                >
                    Sim, Faturar
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalFaturarPagamento: false,
            tipoMovimento: '',
            dataVencimentoFaturamentoRM: '',
            tiposMovimentosDestino: [],
            nomesTipoMovimento: {
                '1.2.03': '1.2.03 – Nota Fiscal de Serviço - com Retenção',
                '1.2.04': '1.2.04 – Nota Fiscal de Serviço - sem Retenção'
            }
        }
    },

    methods: {
        abrirModalFaturar() {
            if (
                !this.pagamento.comprometimentos ||
                this.pagamento.comprometimentos.length === 0
            ) {
                this.$toast.warning(
                    'Este pagamento não possui serviços para faturar.',
                    'ATENÇÃO',
                    this.$toastConfig.warning
                )
                return
            }

        
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterTiposMovimentoDestino(this.pagamento.pagamentoId)
                .then(response => {
                    this.$store.dispatch('removeRequest')
                    this.tiposMovimentosDestino =
                        (response && response.success && response.data) || []

                    if (this.tiposMovimentosDestino.length === 0) {
                        this.$toast.warning(
                            'Nenhum tipo de movimento destino disponível para os serviços deste pagamento.',
                            'ATENÇÃO',
                            this.$toastConfig.warning
                        )
                        return
                    }

                    this.mostrarModalFaturarPagamento = true
                })
                .catch(() => {
                    this.$store.dispatch('removeRequest')
                    this.$toast.error(
                        'Erro ao obter os tipos de movimento disponíveis para faturamento.',
                        'ERRO',
                        this.$toastConfig.error
                    )
                })
        },

        fecharModalFaturar() {
            this.mostrarModalFaturarPagamento = false
            this.tipoMovimento = ''
            this.dataVencimentoFaturamentoRM = ''
            this.tiposMovimentosDestino = []
            this.$v.$reset()
        },

        confirmarFaturarPagamento() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }

            this.$store.dispatch('addRequest')

            const processamento = {
                pagamentoId: this.pagamento.pagamentoId,
                tipoMovimento: this.tipoMovimento,
                dataVencimentoFaturamentoRM: this.converterDataParaIso(
                    this.dataVencimentoFaturamentoRM
                )
            }

            this.pagamentosServicos
                .faturarPagamento(processamento)
                .then(response => {
                    this.$store.dispatch('removeRequest')

                    if (response && response.success) {
                        this.$toast.success(
                            response.message ||
                                'Pagamento faturado com sucesso!',
                            'SUCESSO',
                            this.$toastConfig.success
                        )
                        this.fecharModalFaturar()
                        this.$emit('obterPagamentoAtualizado')
                    } else {
                        this.$toast.error(
                            response?.message ||
                                'Não foi possível faturar o pagamento no RM.',
                            'ERRO NO FATURAMENTO',
                            this.$toastConfig.error
                        )
                        this.$emit('obterPagamentoAtualizado')
                    }
                })
                .catch(() => {
                    this.$store.dispatch('removeRequest')
                    this.$toast.error(
                        'Erro ao comunicar com o servidor.',
                        'ERRO',
                        this.$toastConfig.error
                    )
                })
        },

        converterDataParaIso(data) {
            if (!data) {
                return null
            }
            const partes = data.split('/')
            if (partes.length !== 3) {
                return null
            }
            return `${partes[2]}-${partes[1]}-${partes[0]}`
        }
    },

    computed: {
        tiposMovimentosOptions() {
            return [
                { value: '', text: 'Selecione um tipo de movimento' },
                ...this.tiposMovimentosDestino.map(cod => ({
                    value: cod,
                    text: this.nomesTipoMovimento[cod] || cod
                }))
            ]
        },

        mostrarBtnFaturarPagamento() {
            return (
                this.pagamento.status ===
                    pagamentoStatus.EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO &&
                this.$temAcesso('GESCON-UFI-PAG-01') &&
                typeof this.pagamentosServicos.obterTiposMovimentoDestino ===
                    'function'
            )
        }
    },

    validations: {
        tipoMovimento: { required },
        dataVencimentoFaturamentoRM: { required }
    }
}
</script>
